import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as paradasActions from 'modules/paradas/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.PARADAS_GET).switchMap(action =>
    ajax(request(action))
      .map(({ response }) =>
        paradasActions.setState({
          lista: response.map(p => Object.assign(p, { fullName: p.alias ? p.alias.concat(` (${p.nombre})`) : p.nombre })),
        }),
      )
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getSugeridasEpic = (action$, store) =>
  action$.ofType(constAction.PARADAS_SUGERIDAS_GET).switchMap(action =>
    ajax(request(action))
      .map(({ response }) =>
        paradasActions.setState({
          paradasSugeridas: response.map(p => Object.assign(p, { fullName: p.alias ? p.alias.concat(` (${p.nombre})`) : p.nombre })),
        }),
      )
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.PARADAS_SET)
    .throttleTime(2000)
    .switchMap(action =>
      ajax(request(action))
        .map(result => paradasActions.actualizarState(result.response))
        .concat(Rx.Observable.of(generalActions.snackbar_show('Parada guardada')))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const setSugeridaEpic = (action$, store) =>
  action$
    .ofType(constAction.PARADAS_SUGERIDAS_SET)
    .throttleTime(2000)
    .switchMap(action =>
      ajax(request(action))
        .mergeMap(() => [paradasActions.get(), paradasActions.getSugeridas(), push('/dashboard/paradas/'), generalActions.snackbar_show('Parada guardada')])
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const deleteEpic = (action$, store) =>
  action$.ofType(constAction.PARADAS_DELETE).switchMap(action =>
    ajax(request(action))
      .mapTo(action.isSugerida ? paradasActions.getSugeridas() : generalActions.snackbar_show('Parada eliminada'))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByIdEpic = (action$, store) =>
  action$.ofType(constAction.PARADAS_GET_BY_ID).switchMap(action =>
    ajax(request(action))
      .map(result => paradasActions.setState({ parada: result.response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

//-- EPICS DE OTROS COMPONENTES
export const getRutinasEpic = (action$, store) =>
  action$.ofType(constAction.PARADAS_RUTINAS_GET).switchMap(action =>
    ajax(request(action))
      .map(result => paradasActions.setState({ rutinas: result.response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export default combineEpics(getEpic, setEpic, deleteEpic, getByIdEpic, getRutinasEpic, getSugeridasEpic, setSugeridaEpic);



// WEBPACK FOOTER //
// src/modules/paradas/epics.js